"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var _data = _interopRequireDefault(require("./data"));
var InternalCascader = _antd.Cascader._InternalPanelDoNotUseOrYouWillBeFired;
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(InternalCascader, {
    options: _data.default,
    open: true,
    disabled: true,
    placeholder: "Please select"
  });
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorBgContainerDisabled'],
  key: 'disabled'
};
var _default = exports.default = componentDemo;